import { create } from "zustand";

export interface Toast {
  id: string;
  type: "success" | "error" | "info" | "warning";
  title: string;
  description?: string;
}

interface AppState {
  toasts: Toast[];
  addToast: (t: Omit<Toast, "id">) => void;
  removeToast: (id: string) => void;
  /** Globale Schnellsuche (Cmd/Strg+K) — siehe components/layout/QuickSwitcher.tsx. */
  quickSwitcherOpen: boolean;
  setQuickSwitcherOpen: (v: boolean) => void;
}

export const useAppStore = create<AppState>((set, get) => ({
  toasts: [],
  addToast: (t) => {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    set((s) => ({ toasts: [...s.toasts, { ...t, id }] }));
    // Fehlermeldungen bleiben länger stehen, damit man sie in Ruhe lesen kann.
    setTimeout(() => get().removeToast(id), t.type === "error" ? 10000 : 4500);
  },
  removeToast: (id) =>
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
  quickSwitcherOpen: false,
  setQuickSwitcherOpen: (v) => set({ quickSwitcherOpen: v }),
}));
